import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Layout from "./hocs/Layout";
import Orders from "./containers/Orders/Orders";
import OrderDetails from "./containers/Orders/OrderDetails";
import AuthPage from "./containers/AuthPage/AuthPage";
import Dummy from "./containers/Orders/Dummy";
import PrivateRoute from "./components/PrivateRoute";
import Settlements from "./containers/Settlements/Settlements";
import SettlementDetails from "./containers/Settlements/SettlementDetails";
import { ContactUs } from "./containers/ContactUs/ContactUs";
import Faq from "./containers/Faq/Faq";
import Helpcenter from "./components/Helpcenter/Helpcenter";
import Recons from "./containers/Recons/Recons";
import ReconDetails from "./containers/Recons/ReconDetails";
import Reports from "./containers/Reports/Reports";
import Settings from "./containers/Settings/Settings";
import MiscSettlement from "./containers/MiscSettlement/MiscSettlement";
import MiscSettlementDetails from "./containers/MiscSettlement/MiscSettlementDetails";
import Services from "./containers/Services/Services";
import Analytics from "./containers/Analytics/Analytics";
import Payout from "./containers/Payout/Payout";

function App() {
  const { authData } = useSelector((state) => state.loginSlice);

  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />
      <Route element={<PrivateRoute />}>
        <Route path="/services" element={<Services />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/analytics" replace />} />
          <Route path="/analytics" element={<Analytics/>} />
          <Route path="/payout" element={<Payout/>} />

          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:orderId" element={<OrderDetails />} />
          <Route path="/dummy" element={<Dummy />} />
          <Route path="/settlements" element={<Settlements />} />
          <Route
            path="/settlements-detail/:settlementId"
            element={<SettlementDetails />}
          />
          <Route path="/misc-settlements" element={<MiscSettlement />} />
          <Route
            path="/misc-settlements-detail/:settlementId"
            element={<MiscSettlementDetails />}
          />

          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/help-center" element={<Helpcenter />} />
          <Route path="/recons" element={<Recons />} />
          <Route path="/recons-detail/:reconId" element={<ReconDetails />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Route>

      {/* <Route
        path="*"
        element={<Navigate to={authData ? "/orders" : "/login"} replace />}
      /> */}
    </Routes>
  );
}

export default App;
